// eslint-disable-next-line @typescript-eslint/typedef
export const GetSideMetricsAsyncEvents = {
  getPlaybackSpeedControllerMetrics: 'getSideMetricsAsyncEvents.getPlaybackSpeedControllerMetrics',
  playbackSpeedControllerMetricsAvailable: 'getSideMetricsAsyncEvents.playbackSpeedControllerMetricsAvailable',
  getPlayingTimeFraction: 'getSideMetricsAsyncEvents.getPlayingTimeFraction',
  getPlayingTimeFractionAvailable: 'getSideMetricsAsyncEvents.getPlayingTimeFractionAvailable',
};
